<template>
  <a-spin :spinning="loading">
    <a-card class="spin-content box" :bordered="false">
      <h2>Postęp kursu</h2>
      <a-progress :percent="course.progress" />
      <div class="text">
        Odbytych zajęć:
        <strong>{{ course.hours_elapsed }}h / {{ course.hours }}h</strong><br />
        Pozostałych godzin do wykorzystania:
        <strong>{{ course.remaining_hours_to_reserve }}h</strong>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import { Course } from '@/api'

export default {
  data() {
    return {
      course: {},
      loading: false
    }
  },
  props: {
    courseId: {
      type: [Number, String],
      required: true
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      Course.get(this.courseId)
        .then(res => {
          this.course = res.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .text {
  margin-top: 16px;
}
</style>
